import { apiClient } from "../client";
import type { Envelope, Product } from "./catalog";

/** Upstream wishlist-line shape is loosely documented — keep permissive. */
export interface WishlistItem {
  id: number;
  product_id: number;
  product?: Product;
  [key: string]: unknown;
}

export interface WishlistMutationResponse {
  status: boolean;
  message?: string;
  [key: string]: unknown;
}

export interface WishlistCount {
  count: number;
}

export const wishlist = {
  /** Signed-in user's saved wishlist. */
  list: () => apiClient.get<Envelope<WishlistItem[]> | WishlistItem[]>("/wishlist"),

  /** Save a product to the wishlist. */
  add: (product_id: number) =>
    apiClient.post<WishlistMutationResponse>("/wishlist/add-to-wishlist", { product_id }),

  /** Remove a wishlist line — upstream deletes by the wishlist row `id`, NOT
   * the product id (a product id is silently ignored: 200 + status:false). */
  remove: (id: number) =>
    apiClient.post<WishlistMutationResponse>("/delete-wishlist", { id }),

  /** Item count for the header badge. */
  count: () => apiClient.get<Envelope<WishlistCount> | WishlistCount>("/wishlist/count"),
};
